import styles from "./EditMapTitle.module.css";

export default function EditMapTitle({ level }) {
  return (
    <div className={styles.editMapTitle}>
      <label>
        <span className="label-text">LEVEL TITLE</span>
        <input
          type="text"
          value={level.title}
          onChange={(e) => {
            level.editor.updateTitle(e.target.value);
          }}
        />
      </label>
    </div>
  );
}
